import moment from 'moment';

export const dateToString = (date, format) => {
  if (date && format) return `${moment(date).format(format)}`;

  return date;
};
